import { EmailTemplateType } from 'shared/models/email-templates'
import {
  Alignment,
  Bold,
  Essentials,
  GeneralHtmlSupport,
  Italic,
  Mention,
  Paragraph,
  Undo,
  Underline,
  Heading,
  Link,
  List,
  Image,
  ImageInsertViaUrl,
  AutoImage,
  ImageToolbar,
  ImageCaption,
  ImageTextAlternative,
  ImageResizeEditing,
  ImageResizeHandles,
  LinkImage,
  ImageResize,
  ImageStyle,
  SourceEditing,
  type EditorConfig
} from 'ckeditor5'
import 'ckeditor5/ckeditor5.css'

const emailTypeNames: Record<EmailTemplateType, string> = {
  ReservationCancel: 'Отмена бронирования',
  ReservationCreate: 'Создание бронирования'
}

const emailTypeColors: Record<EmailTemplateType, string> = {
  ReservationCancel: '#f44336',
  ReservationCreate: '#4caf50'
}

const imageConfiguration = {
  resizeOptions: [
    {
      name: 'resizeImage:original',
      value: null,
      label: 'Original'
    },
    {
      name: 'resizeImage:custom',
      label: 'Custom',
      value: 'custom'
    },
    {
      name: 'resizeImage:40',
      value: '40',
      label: '40%'
    },
    {
      name: 'resizeImage:60',
      value: '60',
      label: '60%'
    }
  ],
  toolbar: [
    'linkImage',
    '|',
    'imageTextAlternative',
    'toggleImageCaption',
    '|',
    'imageStyle:inline',
    'imageStyle:wrapText',
    'imageStyle:breakText',
    '|',
    'resizeImage'
  ]
}

const editorConfig: EditorConfig = {
  toolbar: {
    items: [
      'heading',
      '|',
      'undo',
      'redo',
      '|',
      'bold',
      'italic',
      'underline',
      '|',
      'alignment',
      '|',
      'bulletedList',
      'numberedList',
      '|',
      'link',
      'imageInsert',
      '|',
      'sourceEditing'
    ]
  },
  image: imageConfiguration,
  alignment: {
    // Без className выравнивание выводится инлайновым стилем style="text-align:center",
    // а не CSS-классом — именно это нужно почтовым клиентам, классы там не работают.
    options: ['left', 'center', 'right', 'justify']
  },
  htmlSupport: {
    // name: /.*/ включает не только все определения DataSchema, но и CustomElementSupport
    // (он подписан на register:$customElement) — без этого произвольные теги вырезались бы.
    // styles и classes перечислены отдельно: attributes: true намеренно исключает style и class.
    allow: [{ name: /.*/, attributes: true, classes: true, styles: true }],
    disallow: [
      { name: 'script' },
      // Массивная форма обязательна: объектная ({ key: /^on./ }) разбирается через
      // Object.entries и матчит атрибут с буквальным именем "key", а не по маске.
      { name: /.*/, attributes: [{ key: /^on./, value: true }] }
    ]
  },
  plugins: [
    Heading,
    Bold,
    Essentials,
    Italic,
    Mention,
    Paragraph,
    Undo,
    Underline,
    Alignment,
    Link,
    List,
    Image,
    AutoImage,
    ImageInsertViaUrl,
    ImageToolbar,
    ImageCaption,
    ImageTextAlternative,
    LinkImage,
    ImageResize,
    ImageResizeEditing,
    ImageResizeHandles,
    ImageStyle,
    GeneralHtmlSupport,
    SourceEditing
  ]
}

export { emailTypeNames, emailTypeColors, editorConfig }
